import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginacaoSale } from '../page/sale/paginacaoSales';
import { Sale } from '../page/sale/sale';
import { SaleAReceber } from '../page/areceber-dialog-pagamento/saleAReceber';

@Injectable({
  providedIn: 'root'
})
export class SaleService {

  apiURL: string = environment.apiBaseUrl + 'sale';

  constructor(private http: HttpClient) { }

  save(sale: Sale): Observable<Sale> {
    return this.http.post<Sale>(this.apiURL, sale);
  }

  list(page: number, size: number): Observable<PaginacaoSale> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  somaTotal(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/somatotal`);
  }

  totalVendas(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/count`);
  }

  salesLimit(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/limit`);
  }

  imprimir(sale: Sale): Observable<any> {    
    return this.http.post<HttpResponse<Blob>>(`${this.apiURL}/imprimir`, sale);
  }

  findSale(page: number, size: number , dataInicio: string, dataFim: string): Observable<PaginacaoSale> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString()).set('dataInicio', dataInicio).set('dataFim', dataFim);
    return this.http.get<any>(`${this.apiURL}/consulta?${params.toString()}`);
  }
 
  relatorio(param1: string, param2: string): Observable<HttpResponse<Blob>> {
    const params = new HttpParams()
      .set('param1', param1)
      .set('param2', param2);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    });

    return this.http.get(`${this.apiURL}/relatorio`, {
      params: params,
      headers: headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

  cupomFiscal(): Observable<HttpResponse<Blob>> {
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    });

    return this.http.get(`${this.apiURL}/cupomFiscal`, {      
      headers: headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

  listarAReceber(): Observable<any> {
    return this.http.get<any>(`${this.apiURL}/listaAteceber`);
  }

  listarAReceberCliente(id:number): Observable<any> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<any>(`${this.apiURL}/listaArecebeCliente?${params.toString()}`);
  }

  saveAreceber(saleAReceber: SaleAReceber): Observable<SaleAReceber> {
    return this.http.post<SaleAReceber>(this.apiURL+'/saveAreceber', saleAReceber);
  }

  emitirNotaFiscal(id:number): Observable<any> {
    const params = new HttpParams().set('id', id.toString());    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    });
    return this.http.get(`${this.apiURL}/emitirNota?${params.toString()}`, {      
      headers: headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

  historicoCliente(id:number): Observable<any>{
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<any>(`${this.apiURL}/historicoCliente?${params.toString()}`);
  }

  grafico(idProduto:number): Observable<any>{
    const params = new HttpParams().set('idProduto', idProduto.toString());
    return this.http.get<any>(`${this.apiURL}/grafico?${params.toString()}`);
  }

  graficoVendaDiaProduto(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/vendaProdutoDia`);
  }
  

}